import React from 'react';

const formatNumberCompact = (num) => {
  if (num === null || num === undefined) return '';
  const cleanVal = typeof num === 'string' ? num.replace(/,/g, '') : num;
  const val = Number(cleanVal);
  if (isNaN(val)) return String(num); // return original if not a number
  if (val >= 1000000) {
    return (val / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
  }
  if (val >= 1000) {
    return (val / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
  }
  return val.toLocaleString();
};

const StatsCard = ({ 
  title, 
  value, 
  icon: Icon, 
  onClick, 
  className = "",
  showLimit = false,
  current = 0,
  limit = 0,
  iconColor = "text-gray-300"
}) => {
  const isNumeric = typeof value === 'number' || !isNaN(Number(String(value).replace(/,/g, '')));
  const cleanVal = isNumeric ? Number(String(value).replace(/,/g, '')) : null;
  const tooltipText = isNumeric && cleanVal !== null ? cleanVal.toLocaleString() : undefined;
  
  return (
    <div 
      className={`group relative overflow-hidden rounded-xl sm:rounded-2xl bg-black p-4 sm:p-6 border border-gray-800 hover:border-gray-700 transition-all duration-300 hover:shadow-xl ${className}`}
      onClick={onClick}
    >
      <div className="flex items-center">
        <div className="flex-shrink-0">
          <div className="h-10 w-10 sm:h-12 sm:w-12 bg-gray-900 rounded-lg sm:rounded-xl flex items-center justify-center">
            <Icon className={`h-5 w-5 sm:h-6 sm:w-6 ${iconColor}`} />
          </div>
        </div>
        <div className="ml-3 sm:ml-4 flex-1 min-w-0">
          <p className="text-xs sm:text-sm font-medium text-gray-400 text-left truncate">{title}</p>
          <div className="flex items-baseline">
            <p className="text-lg sm:text-2xl font-bold text-white truncate" title={tooltipText}>
              {showLimit ? current : formatNumberCompact(value)}
            </p>
            {showLimit && (
              <span className="text-xs sm:text-sm font-normal text-gray-500 ml-1 flex-shrink-0">
                /{limit === -1 ? '∞' : limit}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsCard;